// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-dialog {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 1rem;
}
.create-dialog button {
  width: 10rem;
}

::ng-deep .width-15 {
  width: 15rem;
}

.save-list {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: baseline;
  flex-wrap: wrap;
}
.save-list .save-list-actions {
  display: flex;
  gap: 1rem;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImZpbHRlci1zYXZlLWxpc3QuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDSSxhQUFBO0VBQ0Esc0JBQUE7RUFDQSxTQUFBO0VBQ0EsWUFBQTtBQUNKO0FBQ0k7RUFDSSxZQUFBO0FBQ1I7O0FBR0E7RUFDSSxZQUFBO0FBQUo7O0FBR0E7RUFDSSxhQUFBO0VBQ0EsOEJBQUE7RUFDQSxtQkFBQTtFQUNBLHFCQUFBO0VBQ0EsZUFBQTtBQUFKO0FBRUk7RUFDSSxhQUFBO0VBQ0EsU0FBQTtBQUFSIiwiZmlsZSI6ImZpbHRlci1zYXZlLWxpc3QuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuY3JlYXRlLWRpYWxvZyB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgIGdhcDogMXJlbTtcbiAgICBtYXJnaW46IDFyZW07XG5cbiAgICBidXR0b24ge1xuICAgICAgICB3aWR0aDogMTByZW07XG4gICAgfVxufVxuXG46Om5nLWRlZXAgLndpZHRoLTE1IHtcbiAgICB3aWR0aDogMTVyZW07XG59XG5cbi5zYXZlLWxpc3Qge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICAgIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gICAgYWxpZ24taXRlbXM6IGJhc2VsaW5lO1xuICAgIGZsZXgtd3JhcDogd3JhcDtcblxuICAgIC5zYXZlLWxpc3QtYWN0aW9ucyB7XG4gICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgIGdhcDogMXJlbTtcbiAgICB9XG59Il19 */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/components/filter/filter-save-list/filter-save-list.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AACJ;AACI;EACI,YAAA;AACR;;AAGA;EACI,YAAA;AAAJ;;AAGA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AAAJ;AAEI;EACI,aAAA;EACA,SAAA;AAAR;AACA,wiCAAwiC","sourcesContent":[".create-dialog {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    margin: 1rem;\n\n    button {\n        width: 10rem;\n    }\n}\n\n::ng-deep .width-15 {\n    width: 15rem;\n}\n\n.save-list {\n    display: flex;\n    justify-content: space-between;\n    flex-direction: row;\n    align-items: baseline;\n    flex-wrap: wrap;\n\n    .save-list-actions {\n        display: flex;\n        gap: 1rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
